module.exports = __webpack_public_path__ + "img/Tencent.af8a1df2.jpg";